import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { Md5 } from 'ts-md5';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  barrierKey: string = '';
  UUID: string = '';

  constructor(
    private cookieService: CookieService,
  ) { }

  encryptData(data) {
    try {
      const getEncryptVal = CryptoJS.AES.encrypt(JSON.stringify(data), environment.encryptSecretKey).toString();
      return getEncryptVal;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_) {
      return undefined;
    }
  }

  decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, environment.encryptSecretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8)).value;
      }
      return data.value;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_) {
      return undefined;
    }
  }


  setLocalStorage(opts) {
    const value: string = '' + this.encryptData({ value: opts.value });
    localStorage.setItem(Md5.hashAsciiStr(environment.baseUrl + opts.key).toString(), value);
  }

  getLocalStorage(opts: { key }) {
    const key = Md5.hashAsciiStr(environment.baseUrl + opts.key).toString();
    return this.decryptData(localStorage.getItem(key));
  }

  removeLocalStorage(opts: { key }) {
    const key = Md5.hashAsciiStr(environment.baseUrl + opts.key).toString();
    return localStorage.removeItem(key);
  }

  setHeaderEncryptData(data) {
    if (data != null && data != undefined && data != '') {
      this.generateUUID();
      const encryptData = data + this.UUID;
      const getEncryptVal = CryptoJS.SHA256(encryptData);
      this.barrierKey = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA1(getEncryptVal, environment.ForceApiKey));
    }
  }

  generateUUID() {
    const dictionary = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPWRSTUVWXYZ0123456789-!@#$%&=+";
    let UUID1 = '';
    for (let i = 0; i < 64; i++) {
      UUID1 += dictionary[Math.floor(Math.random() * dictionary.length)];
    }
    this.UUID = UUID1;
  }

  setCookie(key: string, value) {
    this.cookieService.set(key, value);
  }

  getCookie(key: string) {
    return this.cookieService.get(key);
  }

  checkCookie(key: string) {
    return this.cookieService.check(key);
  }

  getAllCookie() {
    return this.cookieService.getAll();
  }

  deleteCookie(key: string) {
    return this.cookieService.delete(key);
  }

  deleteAllCookie() {
    return this.cookieService.deleteAll();
  }

  private authSource: BehaviorSubject<unknown> = new BehaviorSubject(0);
  updateOnAuthChange(login) {
    this.authSource.next(login);
  }
}
